import { render } from "./a-menu-navigation.vue?vue&type=template&id=ad251238&scoped=true"
import script from "./a-menu-navigation.vue?vue&type=script&lang=js"
export * from "./a-menu-navigation.vue?vue&type=script&lang=js"

import "./a-menu-navigation.vue?vue&type=style&index=0&id=ad251238&lang=sass&scoped=true"

import exportComponent from "/opt/bitnami/apps/ocmsta/subdomains/praxisti/htdocs/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad251238"]])

export default __exports__